<template>
    <div class="gmf-loot-crate-open-wrapper">
        <button class="gmf-loot-crate-btn" @click="openLootCrate">
            <Icon class="gmf-loot-crate-btn-icon" icon="loot-crate"></Icon>
        </button>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import createLootCratesModal from '@/widgets/LootCrate/createLootCratesModal';

export default {
    components: {
        Icon
    },

    methods: {
        openLootCrate() {
            createLootCratesModal()
        },
    },
};
</script>


<style>
.gmf-loot-crate-open-wrapper {
    cursor: pointer;
}

.gmf-loot-crate-btn {
    border: 0;
    padding: var(--gmf-p-2) var(--gmf-p-3);
    background-color: var(--gmf-brand-color);
    border-radius: var(--gmf-modal-rounding);
    cursor: pointer;
}

.gmf-loot-crate-btn-icon {
    width: 15px !important;
    height: 21px !important;
    min-width: 14px !important;
}

.gmf-loot-crate-btn-icon.gmf-icon {
    --gmf-icon-color: var(--gmf-col-white) !important;
}
</style>
